function Privacy() {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.title}>Privacy Policy</h1>
        <p style={styles.date}>Last updated: April 2026</p>

        <section style={styles.section}>
          <h2 style={styles.heading}>1. Introduction</h2>
          <p style={styles.body}>Menu Board is operated in compliance with the Nigeria Data Protection Act (NDPA) 2023. This policy explains how we collect, use, and protect personal data in connection with our platform.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>2. Data We Collect</h2>
          <p style={styles.body}>We collect the following data from restaurant owners who register on our platform: name, email address, and restaurant details. We do not collect any personal data from customers who view menu boards.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>3. How We Use Your Data</h2>
          <p style={styles.body}>We use the data provided by restaurant owners solely to operate and maintain their menu board accounts. We do not sell, share, or transfer personal data to third parties for marketing purposes.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>4. Customer Data</h2>
          <p style={styles.body}>Customers who view menu boards through our platform do so anonymously. No personal data is collected from customers without their explicit consent.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>5. Data Security</h2>
          <p style={styles.body}>All data is transmitted over encrypted connections (HTTPS). Passwords are stored using industry-standard hashing. We take reasonable technical and organisational measures to protect your data.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>6. Data Retention</h2>
          <p style={styles.body}>We retain restaurant account data for as long as the account remains active. Upon account deactivation, data is retained for a period necessary to comply with legal obligations.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>7. Your Rights</h2>
          <p style={styles.body}>Under the NDPA 2023, you have the right to access, correct, or request deletion of your personal data. To exercise these rights, please contact us directly.</p>
        </section>

        <section style={styles.section}>
          <h2 style={styles.heading}>8. Contact</h2>
          <p style={styles.body}>For any privacy-related enquiries, please contact us at contact@menuboard.ng</p>
        </section>

        <a href="/" style={styles.back}>Back to home</a>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', backgroundColor: '#f9f9f9', fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, sans-serif' },
  content: { maxWidth: '700px', margin: '0 auto', padding: '48px 24px' },
  title: { fontSize: '28px', fontWeight: '700', color: '#1a1a1a', marginBottom: '8px' },
  date: { fontSize: '13px', color: '#888', marginBottom: '32px' },
  section: { marginBottom: '32px' },
  heading: { fontSize: '17px', fontWeight: '700', color: '#1a1a1a', marginBottom: '10px' },
  body: { fontSize: '15px', color: '#444', lineHeight: 1.7 },
  back: { display: 'inline-block', marginTop: '16px', fontSize: '14px', color: '#c0392b' },
};

export default Privacy;
